export const ROUTE_PATHS = {
	VANITY: '/s/:ref',
	REF: '/:ref',
	ORDER_SETTINGS: 'order-settings',
	SOLD_OUT_WARNING: 'sold-out-warning',
	EDIT_ITEM: 'edit/:cartItemId',
	ADD_ITEM: ':guid',
	ACCOUNT: 'account',
	ENTRY: 'entry',
	UPDATE_PASSWORD: 'update-password',
	CHECKOUT: 'checkout',
	CONFIRMATION: 'confirmation',
	USER_PROFILE: 'user-profile',
	NOT_FOUND_CATCH_ALL: '*',
	NOT_FOUND: '/not-found',
} as const

export const PATHS = {
	menu: (ref: string) => `/${ref}`,
	orderSettings: (ref: string) => `/${ref}/order-settings`,
	soldOutWarning: (ref: string) => `/${ref}/sold-out-warning`,
	editItem: (ref: string, cartItemId: string) => `/${ref}/edit/${cartItemId}`,
	addItem: (ref: string, guid: string) => `/${ref}/${guid}`,
	accountEntry: (ref: string) => `/${ref}/account/entry`,
	updatePassword: (ref: string) => `/${ref}/account/update-password`,
	checkout: (ref: string) => `/${ref}/checkout`,
	checkoutSoldOutWarning: (ref: string) => `/${ref}/checkout/sold-out-warning`,
	checkoutAccountEntry: (ref: string) => `/${ref}/checkout/account/entry`,
	confirmation: (ref: string, orderRef?: string) =>
		orderRef
			? `/${ref}/confirmation?orderRef=${encodeURIComponent(orderRef)}`
			: `/${ref}/confirmation`,
	userProfile: (ref: string) => `/${ref}/user-profile`,
	vanity: (ref: string) => `/s/${ref}`,
	notFound: () => '/not-found',
}
